import React from "react";
import { Dialog } from "@headlessui/react";
import { useSessionStorageValue } from "@react-hookz/web";
import { useTranslation } from "gatsby-plugin-react-i18next";
import { Modal, ModalPanel } from "components/Modal";
import { Button } from "components/Button";

export function AgeWarningModal() {
    const { t } = useTranslation();
    const [confirmed, setConfirmed] = useSessionStorageValue(
        "age_confirmed",
        false
    );
    const preventClose = () => {};
    const onConfirm = () => setConfirmed(true);
    const onCancel = () => {
        window.history.back();
    };

    return (
        <Modal open={!confirmed} onClose={preventClose}>
            <ModalPanel>
                <div className="space-y-4 mb-8">
                    <Dialog.Title className="text-3xl">
                        {t("title.adult_warning")}
                    </Dialog.Title>
                    <Dialog.Description>
                        {t("description.adult_warning")}
                    </Dialog.Description>
                </div>

                <div className="grid grid-cols-2 gap-4 mt-10 max-w-xs mx-auto">
                    <Button stretch variant="secondary" onClick={onCancel}>
                        {t("button.under_18")}
                    </Button>
                    <Button stretch onClick={onConfirm}>
                        {t("button.over_18")}
                    </Button>
                </div>
            </ModalPanel>
            <p className="text-xs text-left md:text-base md:px-8">
                {t("information.adult_warning")}
            </p>
        </Modal>
    );
}
